import getHelper from '../../../services/getHelper';

export default getHelper('/video-conferences/:id', {
  records: getHelper('/records/:id'),
  startRecording: getHelper('/start-recording'),
  stopRecording: getHelper('/stop-recording'),
  recoverRecords: getHelper('/recover-records'),
  reportUnusable: getHelper('/report-unusable'),
  elapsedDuration: getHelper('/elapsed-duration'),
});
